import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from './api/client';
import Ornament from './components/Ornament';
import Icon from './components/Icon';
import './JobListings.css';

const JobListings = () => {
    const [jobs, setJobs] = useState([]);
    const [userRole, setUserRole] = useState(null);
    const [appliedJobs, setAppliedJobs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const fetchJobs = async () => {
            try {
                setIsLoading(true);
                const path = location.search
                    ? `/api/job/postjobs${location.search}`
                    : `/api/job/postjobs?status=Active`;
                const data = await api.get(path);
                setJobs(data);
            } catch (error) {
                console.error("Error fetching jobs:", error);
            } finally {
                setIsLoading(false);
            }
        };

        const fetchAppliedJobs = async () => {
            try {
                if (!localStorage.getItem('token')) return;
                const data = await api.get(`/api/job/applied-jobs/me`);
                setAppliedJobs((data || []).map((job) => job._id));
            } catch (error) {
                console.error("Error fetching applied jobs:", error);
            }
        };

        fetchJobs();
        fetchAppliedJobs();
        setUserRole(localStorage.getItem('role'));
    }, [location.search]);

    const handleApplyClick = (job) => {
        navigate("/apply", { state: { formElements: job.formElements, jobId: job._id } });
    };

    const primaryField = (job) => {
        if (!job.fields || !job.fields.length) return 'Untitled role';
        return job.fields[0].value || 'Untitled role';
    };

    return (
        <section className="jl-page">
            <header className="jl-header">
                <div className="sw-section-mark">Opportunities</div>
                <h1>Open positions across the Dharmik network</h1>
                <p className="jl-subtitle">
                    {jobs.length > 0
                        ? `${jobs.length} active opportunit${jobs.length === 1 ? 'y' : 'ies'} from partner institutions, businesses, temples and families.`
                        : 'Open positions from partner institutions, businesses, temples and families.'}
                </p>
            </header>

            <div className="jl-container">
                {isLoading ? (
                    <div className="jl-empty">
                        <Ornament variant="lotus" tone="gold" size={48} />
                        <p>Loading opportunities…</p>
                    </div>
                ) : jobs.length === 0 ? (
                    <div className="jl-empty">
                        <Ornament variant="flourish" tone="gold" size={56} />
                        <h3>No opportunities match your search</h3>
                        <p>Try adjusting your filters, or browse all openings from the home page.</p>
                        <button className="sw-btn sw-btn-ghost sw-btn-sm" onClick={() => navigate('/')}>
                            <Icon name="arrow" size={14} style={{ transform: 'scaleX(-1)' }} />
                            <span>Back to home</span>
                        </button>
                    </div>
                ) : (
                    <div className="jl-grid">
                        {jobs.map((job) => {
                            const applied = appliedJobs.includes(job._id);
                            return (
                                <article key={job._id} className="jl-card">
                                    <header className="jl-card-head">
                                        <h3>{primaryField(job)}</h3>
                                        <span className="sw-tag sw-tag-success">Active</span>
                                    </header>
                                    <div className="jl-card-fields">
                                        {job.fields.slice(1, 5).map((field, index) => (
                                            <div key={field._id || index} className="jl-field">
                                                <span className="jl-field-label">{field.label}</span>
                                                <span className="jl-field-value">{field.value || '—'}</span>
                                            </div>
                                        ))}
                                    </div>
                                    <footer className="jl-card-foot">
                                        {userRole === 'candidate' ? (
                                            applied ? (
                                                <button className="sw-btn sw-btn-ghost sw-btn-sm" disabled>
                                                    <Icon name="check" size={14} />
                                                    <span>Applied</span>
                                                </button>
                                            ) : (
                                                <button
                                                    className="sw-btn sw-btn-saffron sw-btn-sm"
                                                    onClick={() => handleApplyClick(job)}
                                                >
                                                    <span>Apply now</span>
                                                    <Icon name="arrow" size={14} />
                                                </button>
                                            )
                                        ) : (
                                            <button
                                                className="sw-btn sw-btn-ghost sw-btn-sm"
                                                onClick={() => navigate(`/job-details/${job._id}`)}
                                            >
                                                <span>View details</span>
                                                <Icon name="arrow" size={14} />
                                            </button>
                                        )}
                                    </footer>
                                </article>
                            );
                        })}
                    </div>
                )}
            </div>
        </section>
    );
};

export default JobListings;
